//  Name: fb-button
import Auth from '@/helpers/facebook'
import { EVENTS } from '@/helpers/facebook'
import EventBus from '@/helpers/event-bus'

const SIGNAL = 'Facebook'
const LOGIN = 'LOGIN'
const WAITING = 'WAITING'
const SUCCESS = 'SUCCESS'
const FAILED_AUTH = 'FAILED_AUTH'
const FAILED_SERVER = 'FAILED_SERVER'

export default {
  props: {
    api: {
      type: String,
      required: true
    },
    busy: {
      type: Boolean
    }
  },
  data () {
    return {
      network: null,
      loading: true,
      login: false
    }
  },
  watch: {
    busy (val) {
      this.login = true
    }
  },
  methods: {
    signIn () {
      this.login = true
      this.$emit('status', SIGNAL, LOGIN)
      this.network.singIn()
    },
    onLoad () {
      this.network.onLoad()
    },
    onReady () {
      this.loading = false
    },
    onAuth (data) {
      this.$emit('status', SIGNAL, SUCCESS, data)
    },
    onFailed (error) {
      this.login = false
      this.$emit('status', SIGNAL, FAILED_AUTH, error)
    }
  },
  mounted () {
    this.$set(this, 'network', Auth())
    this.network.init(this.api)

    EventBus.$on(EVENTS.READY, this.onReady)
    EventBus.$on(EVENTS.SUCCESS, this.onAuth)
    EventBus.$on(EVENTS.FAILED, this.onFailed)
  },
  beforeDestroy () {
    EventBus.$off(EVENTS.READY, this.onReady)
    EventBus.$off(EVENTS.SUCCESS, this.onAuth)
    EventBus.$off(EVENTS.FAILED, this.onFailed)
  }
}



// WEBPACK FOOTER //
// ./src/components/fb-button/script.js